import './FeaturedBenefits.scss';
import { Box, Grid, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import useHandleAnchorClick from '../../hooks/useHandleAnchorClick';

const FeaturedBenefits = ({ data }) => {
  const columnImageUrls = [
    '/images/benefits/featured/featured_icon_1.png',
    '/images/benefits/featured/featured_icon_2.png',
    '/images/benefits/featured/featured_icon_4.png'
  ];

  const handleAnchorClick = useHandleAnchorClick();

  const columnRefs = useRef<(HTMLDivElement | null)[]>([]); 
  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    if (columnRefs.current.length > 0) {
      const heights = columnRefs.current.map((col) =>
        col ? col.clientHeight : 0
      );
      setMaxHeight(Math.max(...heights));
    }
  }, [data]);

  if(!data){
    return null;
  }


  return (
    <Box className="featured-benefits" aria-labelledby="featured-benefits">
      <Typography variant="h2" className="title" id="benefits-feature-title">
        {data.title}
      </Typography>
      <Grid container className="container">
        {data.sections.map((section, index) => (
          <Grid
            item
            className="column"
            key={index}
            lg={4}
            md={6}
            sm={6}
            xs={12}
          >
            <Box className="container-image">
              <img src={columnImageUrls[index]} alt="" />
              <Box
                className="benefits-bg"
                style={{ height: `${maxHeight}px` }}
              ></Box>
            </Box>
            <Box className="container-item"   ref={(el: HTMLDivElement | null) => (columnRefs.current[index] = el)}>
              <Typography className="item-title">{section.title}</Typography>
              <Typography className="item-text" onClick={handleAnchorClick}>
                {section?.list.map((listItem) => (
                  <div
                    key={`ben0-${listItem.id}`}
                    dangerouslySetInnerHTML={{ __html: listItem.item }}
                  ></div>
                ))}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
export default FeaturedBenefits;
